import { useState, useCallback, useEffect } from "react";
import { addressService } from "../services/addressService";
import { authService } from "../services/auth"; // Customer ID için

export const useCustomerAddresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAddresses = useCallback(async () => {
    const currentUser = authService.getCurrentUser();
    const customerId = currentUser?.id; // Kullanıcı objesindeki ID alanı

    if (!customerId) {
      setError(
        "Adresleri getirmek için giriş yapılmalı veya kullanıcı ID bulunamadı."
      );
      setAddresses([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const addressData = await addressService.getCustomerAddresses(customerId);
      console.log("useCustomerAddresses - Gelen Addresses Data:", addressData);
      // Yanıtın doğrudan dizi olduğunu varsayarak kontrolü basitleştirelim (veya API'ye göre ayarlayalım)
      if (Array.isArray(addressData)) {
        setAddresses(addressData);
      } else {
        console.warn(
          "Beklenmeyen adres yanıtı yapısı (dizi değil):",
          addressData
        );
        setAddresses([]);
      }
    } catch (err) {
      setError(err.message || "Adresler getirilemedi");
      console.error("Adres getirme hatası:", err);
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // İlk yüklemede adresleri getir
  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  return {
    addresses,
    loading,
    error,
    refetchAddresses: fetchAddresses, // Yeniden yükleme için
  };
};

// Default export YOK
